module.exports = __webpack_public_path__ + "img/sp_open.57a1e82d.svg";